import type { FleetSize, UserData } from '@cobliteam/common-types';

const getFleetSize = (userData?: UserData): FleetSize => {
  if (!userData) return { size: 'small' as const, total: 0 } as FleetSize;

  const { userAttributes } = userData;
  const { numberOfDevices } = userAttributes;
  let size = 'small'; // default to small

  const fleetSize = {
    small: 15,
    medium: 50,
    large: 250,
    // key account is larger than 250
  };

  if (numberOfDevices <= fleetSize.small) {
    size = 'small';
  } else if (numberOfDevices <= fleetSize.medium) {
    size = 'medium';
  } else if (numberOfDevices <= fleetSize.large) {
    size = 'large';
  } else {
    size = 'xlarge'; // key account
  }

  const smallOrMedium = size === 'small' || size === 'medium';
  const largeOrXlarge = size === 'large' || size === 'xlarge';

  return {
    size,
    total: numberOfDevices,
    smallOrMedium,
    largeOrXlarge,
  } as FleetSize;
};

export default getFleetSize;
